<template>
  <div class="desktop-logo">
    <div class="info">
      <div class="thoughts-container">
        <div class="left">
          <img src="@/assets/images/start/thought4.png" class="thought4" />
          <img src="@/assets/images/start/thought3.png" class="thought3" />
        </div>
        <div class="right">
          <img src="@/assets/images/start/thought1.png" class="thought1" />
          <img src="@/assets/images/start/thought2.png" class="thought2" />
        </div>
      </div>
    </div>
    <div class="sexkampen-wrapper">
      <img src="@/assets/images/start/sexkampen.png" class="sexkampen" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.desktop-logo {
  position: relative;
}
.sexkampen-wrapper {
  position: relative;
}
.sexkampen {
  width: 100%;
  max-width: 333px;
  height: auto;
  left: 0;
}

.thoughts-container {
  display: inline-flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 333px;

  font-size: 1vw;

  .right {
    margin-left: auto;
  }

  .thought2,
  .thought3 {
    margin-left: -17%;
    width: 50%;
  }

  .thought1,
  .thought4 {
    width: 50%;
  }
}
</style>
